import { Request } from 'components/Request.jsx';
import { Html } from "./Html.jsx";

class Autocomplete {
	static getNormalUserOptions(extraOptions = {}) {
		return Autocomplete.createAutocompleteOptions({}, extraOptions);
	}

	static getModUserOptions(extraOptions = {}) {
		return Autocomplete.createAutocompleteOptions({ banned_users: 1 }, extraOptions);
	}

	static createAutocompleteOptions(searchParamExtras = {}, extraOptions = {}) {
		let sourceFunction = Autocomplete.getSourceFunction(searchParamExtras);
		return $.extend({}, Autocomplete.staticOptions, { source: sourceFunction });
	}

	static getSourceFunction(searchParameters = {}) {
		return function(request, response) {
			let defaultParameters = {
				autocomplete: 1,
				json: 1,
				search: request.term
			};
			let data = $.extend({}, defaultParameters, searchParameters);
			Request.apiv1Get('player/search', data)
				.then((result) => {
					var autocompleteList = [];
					_.each(result.users, function(user) {
						user = Users.update(user);
						Autocomplete.addAutoCompleteElementsForUser(autocompleteList, user);
					});
					response(autocompleteList);
				})
				.catch(() => {
					response([]);
				});
		};
	}

	static addAutoCompleteElementsForUser(autocompleteList, user) {
		if(user.autoCompleteElement || user.autoCompleteElementSecondary) {
			if(user.autoCompleteElement) {
				autocompleteList.push(user.autoCompleteElement);
			}
			if(user.autoCompleteElementSecondary) {
				autocompleteList.push(user.autoCompleteElementSecondary);
			}
		}
		else {
			if(user.display_name) {
				var displayed = $('<span class="username unclickable">');
				displayed.append(Html.encode(user.display_name))
					.append(' (', user.createUsernameElement().addClass('unclickable'), ')');
				user.autoCompleteElementSecondary = {
					label: displayed,
					value: user.username,
					searchValue: user.display_name + user.username,
					isUsername: true
				};
				autocompleteList.push(user.autoCompleteElementSecondary);
			}
			user.autoCompleteElement = {
				label: user.createUsernameElement().addClass('unclickable'),
				value: user.username,
				searchValue: user.username,
				isUsername: true
			};
			autocompleteList.push(user.autoCompleteElement);
		}
	}

	static addInputLoader(element) {
		if(element.data('loaderBarActive')) {
			element.data('loaderBarActive').addClass('active');
		}
		else {
			let loading =
				$('<div class="loading load-bar active">' +
					'<div class="bar"></div>' +
					'<div class="bar"></div>' +
					'<div class="bar"></div>' +
					'</div>');
			element.data('loaderBarActive', loading);
			loading.insertAfter(element);
		}
		element.addClass('has_load_bar');
	}

	static removeInputLoader(element) {
		if(element.data('loaderBarActive')) {
			element.data('loaderBarActive').removeClass('active');
			element.removeClass('has_load_bar');
		}
	}
}

Autocomplete.staticOptions = {
	html: true,
	minLength: 1,
	select: function(event, ui) {
		$(this).val(ui.item.value);
	},
	search: function(event, ui) {
		Autocomplete.addInputLoader($(this));
	},
	response: function(event, ui) {
		Autocomplete.removeInputLoader($(this));
	}
};
$.fn.usernameAutocompleteMod = function(extraData) {
	return $(this).each(function() {
		$(this).autocomplete(Autocomplete.getModUserOptions(extraData));
	});
};
$.fn.usernameAutocomplete = function(extraData) {
	return $(this).each(function() {
		$(this).autocomplete(Autocomplete.getNormalUserOptions(extraData));
	});
};

export { Autocomplete };